export interface RecordState {
    videoFile: File;
    videoName: string;
    userFirstName: string;
    userLastName: string;
    userEmail: string;
    userPhone: string;
    userVideoAgreement?: boolean;
}

const defaultState: RecordState = {
    videoFile: null,
    videoName: "",
    userFirstName: "",
    userLastName: "",
    userEmail: "",
    userPhone: "",
    userVideoAgreement: false
};

export default defaultState;
